<template>
  <div class="content viafree_req">
    <c회원선택2 ref="selectCust" @select="selectCust" />
    <s-location apply title="면제증표 신청"/>

    <h4 class="sub_title02">면제증표 신청</h4>

    <table class="tbl01 t_kindsel">
      <tr>
        <th >면제사건 종류</th>
        <td class="al_l">
          <router-link to="viafree_req">
            <input type="radio" name="freetype" id="rfree_1" checked="checked"/> <label for="rfree_1" v-cursor>일반면제</label>
          </router-link><br class="mobile"/>
  <!-- 마스터인 경우 : 일반면제 & 복대리만 신청 가능 -->
          <router-link to="viafree_choffice" class="via_kind" v-if="$store.state.session.user.type != 'master'">
            <input type="radio" name="freetype" id="rfree_2"/> <label for="rfree_2" v-cursor>소속 변경으로 인한 면제</label>
          </router-link>
          <br class="mobile" />
          <router-link to="viafree_bokdari" class="via_kind">
            <input type="radio" name="freetype" id="rfree_3"/> <label for="rfree_3" v-cursor>복대리 면제</label>
          </router-link>
        </td>
      </tr>
    </table>

    <template v-if="$store.state.session.user.membstat != '개업'">
      <div class="comment_gray expcomment mt_15">
        <p class="tit">신청 권한이 없습니다.</p>
        <li>현재 <b>{{ $store.state.session.user.membstat }}</b> 상태이기 때문에 일반 면제증표 신청을 하실 수 없습니다. (소속 변경으로 인한 면제 신청은 가능) </li>
      </div>
    </template>
    <template v-else>

      <!--
        ** 잘리지 않는 모달을 위한 옵션삽질 기록 **
        ** 필수항목 **
        height="auto" :scrollable="true" 두개는 세트로서 이렇게 해야지 화면이 넘어가도 스크롤이 가능하게 된다. 두값다 필수지정
        reset 사용필수. 잘못해서 화면이 잘린경우라도 reset이 있으면 다시 클릭시 제대로 볼 수 있다
        adaptive 반응형이기 때문에 어쩔 수 없이 쓴다.
        ** 금지항목 **
        draggable 금지 : 화면이 작은경우 draggable 이 한번 작동하면 위가 잘리고 더이상 볼 수 없게된다. 그래서 커다란 modal은 draggable 옵션 사용 금지
        resizable 사용금지. 이유 까먹음. 그냥 쓰지마
      -->
      <!-- draggable=".window-header" -->
      <modal
        name="comment_0101"
        width="900"
        height="auto"
        :scrollable="true"
        :adaptive="true"
        reset
        >
        <div>
          <i-bar title="#별표 4(면제사건)" class="window-header" style="padding-right: 10px;">
            <i-bar-btn @click="$modal.hide('comment_0101')">닫기</i-bar-btn>
          </i-bar>
          <div class="cont" style="padding: 10px;">
            <!-- <p class="brown01 mt0 mb20">본안사건과 신청사건을 수임하여 소송수행 중에 발생되는 부수적･파생적인 사건으로서 각 소송위임장마다 경유증표를 부착하되 경유사건 수를 1건으로 처리하는 사건을 말합니다.</p> -->
            <ol>
              <li>가압류말소촉탁신청, 감수보존신청, 담보취소신청(각 가압류, 가처분신청을 수임한 사건일 경우)</li>
              <li>감정인기피신청</li>
              <li>개인 사건으로 수임하여 진행 중 법무법인을 구성하거나, 그 반대의 경우와 법무법인 명의는 동일하고 대표자명만 변경되어 다시 소송위임장을 제출하는 경우</li>
              <li>공탁(공탁서원본환부신청 포함)</li>
              <li>낙찰대금의 납부, 낙찰완납증명신청, 보관금환급신청, 경매예납금반환신청</li>
              <li>담보권리행사최고</li>
              <li>담보제공허가신청</li>
              <li>담보취소결정확정증명원</li>
              <li>담보취소신청</li>
              <li>대체집행허가신청, 소송비용확정신청, 집행문(승계집행문)부여신청, 집행문 수통(또는 재도) 부여신청서, 판결문(결정문)정본교부신청, 판결등 집행권원 정본의 송달증명원, 판결확정증명신청, 소송기록 제증명신청 등</li>
              <li>문서송부촉탁신청</li>
              <li>배당금지급청구</li>
              <li>법무법인이 수임한 사건으로 그 소속 변호사 명의의 담당지정서를 제출하는 경우</li>
              <li>복대리신청</li>
              <li>비밀보호를 위한 열람등의 제한 신청</li>
              <li>선박등기부초본 또는 등본의 송부청구신청</li>
              <li>소송고지신청</li>
              <li>소송대리권의 증명(위임장, 지정서), 소송대리인 해임(사임)신고</li>
              <li>소송비용담보제공신청</li>
              <li>소송비용액 확정신청</li>
              <li>열람 등 제한 결정 취소신청</li>
              <li>압류금지물의 범위변경신청</li>
              <li>압류금지채권의 범위변경신청</li>
              <li>압류액의 제한(또는 초과액처분) 허가신청</li>
              <li>야간(휴일)집행허가신청</li>
              <li>재산목록의 열람ㆍ복사신청</li>
              <li>재산조회결과의 열람ㆍ복사ㆍ출력신청</li>
              <li>재판, 조서의 정본ㆍ등본ㆍ초본 교부신청</li>
              <li>조정사건이송신청, 조정회부신청</li>
              <li>증거보전신청</li>
              <li>채권자의 가압류(가처분) 집행취소(해제)신청, 채권자의 가압류(가처분) 신청취하를 이유로 하는 채무자의 집행취소신청, 가압류취소재판의 취소재판에 의한 가압류집행신청</li>
              <li>채무불이행자명부 열람ㆍ복사신청</li>
              <li>판결(또는 화해, 인낙, 포기 등의 조서, 지급명령 기타 결정명령) 경정신청</li>
              <li>피고경정신청</li>
              <li>회원이 수임한 무료변론사건(의뢰인이 법인이 아닌 개인으로서 회원 1 인당 연간 10 건에 한하여, 의뢰인의 무료수임확인서를 제출하는 경우에 한함)(2016. 8. 23. 변경)</li>
              <li>이 회의 민사소액사건 소송지원 변호사단의 민사소액사건(2016. 8. 23. 신설)</li>
            </ol>
          </div>
        </div>
      </modal>

      <div id="doViewNormal">
        <!--  주의사항  -->
        <div class="comment_gray expcomment mtb30">
          <p class="tit"> 면제증표 신청 안내</p>
          <li>본회 수임사건경유업무운영지침 <em class="underline blue01" style="cursor: pointer" @click="$modal.show('comment_0101')" >별표 4 (내용보기)</em> 에 명시된 면제사건에 해당할 경우 신청이 가능합니다. </li>
          <li>신청을 원하시는 회원님께서는 하단의 신청서를 작성하시어 제출하시기 바랍니다. 신청내역은 관라지가 확인 후, 이상이 없을 경우 승인처리 됩니다.</li><br/>
          <li>무료변론사건의 경우 의뢰인이 개인일 경우에만 해당되고, 회원 1인당 연간 최대 10건까지만 가능합니다<br/>
              (수임인과 의뢰인의 도장이 날인된 <a href="/static/files/무료_변론_확인서.docx"><span class="btn blue01 s down ">무료변론확인서 (양식 다운)</span></a> 를 작성 및 스캔하여 하단에 파일로 첨부해 주시기 바랍니다).
          </li>
          <!-- <p class="tit"><br/>공익사건이란?</p>
          <li>공익사건은 소송 당사자의 권리 옹호 뿐만 아니라 다수의 시민들에게 이익이 발생되거나, 정부정책 및 제도개선, 법률개정 등에 영향을 미침으로써 사회정의 및 인권옹호 실현에 이바지하는 사건으로서 다음 각호의 사건을 말하며, 공익사건 및 공익단체의 신청 등 구체적인 사항은 지침으로 정한다. (2015.9.1. 변경)</li>
          <li>1. 이 회 상임이사가 공익소송으로 수행하기로 결정한 사건 (2015.9.1. 신설)</li>
          <li>2. 이 회 상임이사가 결의로 지정한 공익단체의 변호사가 수행하는 사건 (2015.9.1. 신설)</li> -->
        </div>

        <table class="tbl01 view01 ">
          <tr>
            <th>구분</th>
            <th>내용</th>
          </tr>
          <tr>
            <th class="req">면제사건 종류</th>
            <td>
              <span v-for="(item , i) in code.FREECLSF" :key="item.value">
                <input
                  type="radio"
                  v-model="sitem.freeclsf"
                  :value="item.value"
                  :id="item.value"
                  class="sch_input"
                />
                <label :for="item.value">{{ item.text}}</label>
                <br class="mobile" v-if=" (i+1) % 2 == 0 " />
              </span>
              <input v-if="sitem.freeclsf == 'B10960' " type="text" v-model="sitem.freeclsf_etc" ref="freeclsf_etc" class="w150"/>
            </td>
          </tr>
          <tr>
            <th class="req">관할기관</th>
            <td>
              <select v-model="sitem.isttoutplac">
                <option value="" selected="selected">선택</option>
                <option v-for="item in code.BG0000"
                        :value="item.text"
                        :key="item.value">{{item.text}}</option>
                <option value="etc">직접 입력</option>
              </select>
              <input v-if="sitem.isttoutplac == 'etc' " type="text" v-model="sitem.isttoutplac_etc"/>
            </td>
          </tr>
          <tr>
            <th>사건번호</th>
            <td> <input type="text" v-model="sitem.caseno" /></td>
          </tr>
          <tr>
            <th class="req">사건명</th>
            <td> <input type="text" v-model="sitem.casenm" /></td>
          </tr>
          <tr>
            <th class="req">위임인</th>
            <td>
              <!-- 위임인 구분 선택 -->
              <select v-model="sitem.clientclsf" @change="onChange_clientclsf">
                <option value="" selected="selected">선택</option>
                <option v-for="item in code.B50000"
                        :value="item.text"
                        :key="item.value">{{item.text}}</option>
                <option value="etc">직접 입력</option>
              </select>
              <!-- 위임인 구분 직접 입력 -->
              <input v-if="sitem.clientclsf == 'etc'" v-model="sitem.clientclsf_etc" type="text"  class="ml2" style="width: 120px;" ref="clientclsf_etc"/>

              <input type="text" v-model="sitem.client" class="ml2" placeholder="위임인 이름 입력" />
            </td>
          </tr>
          <tr>
            <th class="req">상대방</th>
            <td>
              <input type="text" v-model="sitem.otherside" :disabled="othersideDisable"/>
              <label><input v-model="sitem.othersideyn"
                            @change="othersideYN()"
                            true-value="Y"
                            false-value="N"
                            type="checkbox" class="ml10" /> 없음
              </label>
            </td>
          </tr>
          <tr>
            <th class="req">수임일자</th>
            <td>
                <i-input-date  title="수임일자" v-model="sitem.cntchargdt" input-class="w_inputno" @input="onChange_cntchargdt"/>
            </td>
          </tr>
          <tr>
            <th>사건유형</th>
            <td>
              <select v-model="sitem.casetype">
                <option value="" selected="selected">선택</option>
                <option v-for="item in code.B10400" :value="item.value" :key="item.value">{{item.text}}</option>
              </select>
            </td>
          </tr>
          <tr>
            <th> 심급</th>
            <td>
              <select v-model="sitem.simgeup">
                <option value="">선택</option>
                <option v-for="item in code.B11200"
                        :value="item.value"
                        :key="item.value">{{item.text}}</option>
              </select>
              <input v-if="sitem.simgeup == 'B11204'" type="text" v-model="sitem.simgeup_etc"/>
            </td>
          </tr>
          <tr>
            <th class="req">담당변호사</th>
            <td>
                <input type="text" v-model="sitem.search_membnm" @keydown.enter="openCustPop" class="w50p"/>
                <i-btn @click="openCustPop" class="btn xs black01">회원선택</i-btn>
              <div class="damdang_wrap">

                <!-- div 팝업 :: 담당 변호사 검색 결과-->
                <table class="tbl01 list01">
                  <tr>
                    <th width="60">등록번호</th>
                    <th>회원명</th>
                    <th>구분</th>
                  </tr>
                  <tr v-for="(item, i) in selectCustList" :key="i">
                    <td>{{ item.membno }}</td>
                    <td>{{ item.membnm }}</td>
                    <td><span v-if="showChargerDeleteBtn(item)" class="btn xs org01 outline"  @click="delCust(item)" >삭제</span></td>
                  </tr>
                </table>
                <!-- // div 팝업 :: 담당 변호사 검색 결과-->
                <div class="mt10 red01">
                  <template v-if="$store.state.session.user.type == 'self' || $store.state.session.user.officeclsf == 'J' || $store.state.session.user.officeclsf == 'D'"><!-- 개인변호사, 공동법률사무소(소속, 마스터) -->
                    ※ 실제 사건을 담당한 변호사를 모두 입력해 주시기 바랍니다.
                  </template>
                  <template v-else><!-- 법무법인, 법무법인 유한(소속, 마스터) -->
                    ※ 변호사법 제50조(업무집행방법)에 의거, 실제 담당한 변호사를 모두 입력해야 하며, 담당변호사 입력 시 반드시 구성원 변호사를 포함해야 합니다.
                  </template>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th>비고</th>
            <td> <input type="text" v-model="sitem.remk" /></td>
          </tr>
          <tr v-if="sitem.freeclsf == 'B10950'">
            <!-- TODO : 변호사 선택 팝업 -->
            <th class="req">파일첨부</th>
            <td>
              <i-fileupload name="file1" ref="file1" v-model="file1"
                :action="$api + '/attach'"
                autoUpload required
                kind="viafree"
                :exts="'jpeg,jpe,jpg,gif,png,pdf'.split(/,/)"
                @done="file=>sitem.attachid = file.uuid"
                >

                <template v-slot:dropArea="{isDropActive, files}">
                  <div v-if="$mq != 'mobile' && !file1.name" class="file_drag" :style="{ 'background-color': isDropActive ? 'green' : 'gray' }">
                    Drag And Drop
                  </div>
                </template>

                <template v-slot:uploadFile="{file, remove}">
                  {{ file.name }} ( 용량 : {{ file.size }} byte )
                  <i-btn class="btn" @click.prevent="remove(file);sitem.attachid=null" :key="file.id">취소</i-btn>
                </template>

                <i-btn class="btn" v-if="!file1 || !file1.name">업로드파일선택</i-btn>

                &nbsp;
              </i-fileupload>
              <div class="mt10">
                ※ 무료변론 확인서를 스캔하여 첨부해 주세요. (jpg,gif,png,pdf)
              </div>
            </td>
          </tr>
          <!-- 무료변론인 경우 -->
          <tr v-if="sitem.freeclsf == 'B10950'">
            <th class="req">건수차감<br class="mobile" />회원</th>
            <td>
              <select v-model="sitem.freemembno"
                    :disabled="$store.state.session.user.membclsf == 'P'" @change="onChange_freememb">
                <!-- 신동호 -->
                <option value="" selected="selected">선택</option>
                <option v-for="item in openFilter"
                  :value="item.chrgmembno"
                  :key="item.chrgmembno">
                  {{ item.membnm }} ({{ item.membclsf }}/{{ item.chrgmembno }})
                </option>

              </select>
              <!-- 남은 무료변론 횟수 표시 -->
              <span style="color: #FFAF00; padding-left: 10px;">{{ freememb_left_cnt }}</span>
            </td>

          </tr>
        </table>

        <div class="btn_group">
          <div class="right">
            <button @click="initData" class="btn  gray01 outline ">초기화</button>
            <button @click="saveItem" class="btn  gray01 ">신청</button> <!-- href="buy_ok" -->
          </div>
        </div>
      </div> <!--// #doViewNormal -->
    </template>
  </div> <!-- content : width=950px; -->
</template>

<script>
let ui
export default {
  components: {
    "c회원선택2" : require('@/components/c회원선택2.vue').default,
  },
   data () {
    return {
      sitem : {},
      sitem_init : {
        viaregdt       : ''
      , viaseq         : 0
      , selldt         : this.$moment().format("YYYY-MM-DD") // 구입일자 :  오늘
      , viaplac        : 'B21100'                            // 경유처   : 온라인
      , viafee         : 0                                   // 경유회비
      , caseclsf       : 'B10400'                            // 사건구분 : 면제
      , casetype       : ''
      , sellyn         : 'N'                                 // 판매여부
      , statclsf       : 'CH_REQ'                            // 상태구분 : 신고신청
      , viacancelclsf  : ''
      , viacanceldt    : ''
      , cancelclsf     : 'B40100'                            // 사임취하구분 : 공란
      , onlineyn       : 'Y'                                 // 온라인여부 : Y
      , canceldt       : ''
      , simgeup        : ''
      , simgeup_etc    : ''
      , freeclsf_etc   : ''
      , isttoutplac    : ''
      , caseno         : ''
      , casenm         : ''
      , client         : ''
      , otherside      : ''
      , cntchargdt     : ''
      , remk           : ''
      , remk2          : ''
      , rcptno         : ''
      , rcptnoto       : ''
      , agntpersnm     : ''
      , agntpersprn    : ''
      , viadt          : ''
      , clientclsf     : ''
      , etccase        : ''
      , continuyn      : ''
      , linkyn         : ''
      , lostyn         : 'N'
      , lawyernm       : ''
      , freemembno     : ''
      , sellregdt      : ''
      , sellseq        : 0
      , selldtlsseq    : 0
      , attachid       : '' // 첨부파일 ID
      , pay_con        : 0  // 수임액
      , pay_succ       : 0  // 성공보수금
      },
      code : {},
      sCust : null,
      loginInfo : {},
      selectCustList : [],
      file1 : {},
      othersideDisable : false, // 상대방 disabled 여부
      freememb_left_cnt : '',
    }
  },
   watch: {
    "sitem.freeclsf"(v) {
      // 면제사건종류 : 무료변론(B10950) 선택한 경우 차감변호사 로그인 회원으로 기본 선택
      if (v == 'B10950') {
        this.sitem.freemembno = _.get(this.loginInfo, "chrgmembno", "")
        this.onChange_freememb()
      } else {
        this.sitem.freemembno = ''
      }

      // 면제사건종류 : 복대리(B10940) 선택한 경우
      if (v == 'B10940'){
        this.code.B10400 = this.code.B10400.filter(e=> e.value != 'B10402') // [사건유형]에서 형사(B10402)는 제외
        ui.alert("소송복대리 면제증표 신청은  최초 사건을 수임한 본대리인이 신청해야 하며,<br/> 증표번호 입력 시 수임사건 내역이 자동으로 입력됩니다.")
      } else {
        this.code.B10400 = this.code.All_B10400 // [사건유형] 모든 항목
      }

    },
    '$route': 'initData',
  },
  created() {
    ui = this.$ui;
    this.sitem = { ...this.sitem_init }
    // 공통코드 로드
    ui.codeLoad("B10000, B10400, FREECLSF, B11200, BG0000,B50000", code => {
      this.code = code
      this.code.FREECLSF = this.code.FREECLSF.filter(e=> e.value != 'B10910' && e.value != 'B10940') // 소속변경하고 복대리는 제외 ( 따로 탭으로 함 )
      this.code.All_B10400 = this.code.B10400 // 사건유형 목록 all
    });
  },
  mounted() {
    this.setCustList()
  },
  methods : {
    initData(){ // 현재 메뉴 다시 클릭 시
      this.sitem = T.deepCopy(this.sitem_init)
      this.selectCustList = []
      this.setCustList()
    },
    onChange_cntchargdt(v) {
      if (v && this.$moment().format("YYYY-MM-DD") < v) {
        ui.alert("수임일자는 오늘 이후의 날짜를 선택할 수 없습니다.");
        this.sitem.cntchargdt = ''
      } else {
        this.sitem.cntchargdt = v
      }
    },
    showChargerDeleteBtn(item) { // 담당변호사 삭제 버튼
      const 내꺼여부 = this.$store.state.session.user.membno == item.chrgmembno && this.$store.state.session.user.membclsf == 'P'
      return 내꺼여부 ? false : true // 사용시에는 개인내꺼만 아니면 삭제버튼 가능
    },
    setCustList(){
      // 개인 변호사 인 경우 변호사 목록에 본인 추가 및 건수차감회원 본인 기본 선택
      if (this.$store.state.session.user.membclsf == 'P') {

        ui.httpGet('/proc/N_MEM_SEL_INFO_DTL', {},
        ret => {
          this.loginInfo = ret.data.rs1[0]

          //  법인/법인유한,합동 회원의 경우 회원명 : 법인정보도 같이 보여줌
          if (["B", "C", "E", "J", "D"].includes(this.loginInfo.blngmembclsf)) {
            this.loginInfo.membnm = `${this.loginInfo.chrgmembnm}(${this.loginInfo.blngmembnm})`
          }

          this.selectCustList.push({...this.loginInfo });

        })
      }
    },
    openCustPop() {
      if (T.isEmpty(this.sitem.cntchargdt)) {
        return ui.alert("수임일자를 먼저 입력해 주세요.");
      }
      this.$refs.selectCust.open('B', this.sitem.search_membnm, this.sitem.selldt, this.sitem.cntchargdt)
    },
    selectCust(item) {
      if (this.selectCustList.filter(e => e.chrgmembno == item.chrgmembno).length > 0) {
        return ui.alert("이미 추가되어 있습니다.")
      }

      // 검색 회원명 초기화
      this.sitem.search_membnm = ""
      item.membseq = this.selectCustList.length + 1
      this.selectCustList.push(item)
    },
    delCust(item) {
      this.selectCustList = this.selectCustList.filter(e => e.membseq != item.membseq)
    },
    othersideYN(){ // 상대방 - 없음 체크 여부
      if(this.sitem.othersideyn == 'Y'){
        this.sitem.otherside = ''
        this.othersideDisable = true
      } else {
        this.othersideDisable = false
      }
    },
    saveItem() {

      if (this.sitem.freeclsf == 'B10960' && _.isEmpty(this.sitem.freeclsf_etc)) {
        return ui.alert("면제사건종류를 기타로 선택하신경우 \n기타내용을 입력하셔야 합니다.")
          .then(()=>this.$refs.freeclsf_etc.focus())
      }

      if (this.selectCustList.length == 0) {
        return ui.alert("변호사를 선택해 주세요.")
      }

      if(this.sitem.simgeup == 'B11204' && T.isEmpty(this.sitem.simgeup_etc)){
          return ui.alert("심급을 입력해 주세요.")
      }

      if (this.sitem.isttoutplac == 'etc') {
        if (T.isEmpty(this.sitem.isttoutplac_etc)) {
          return ui.alert("관할기관을 입력해 주세요.")
        }
      }

      if (this.sitem.clientclsf == 'etc') {
        if (T.isEmpty(this.sitem.clientclsf_etc)) {
          return ui.alert("위임인 구분을 입력해 주세요.")
        }
      }

      ui.confirm('신청하시겠습니까 ?', "신청확인")
        .then(r => r && this.itemUpdate())
    },
    itemUpdate() {

      this.sitem.freeclsf = this.sitem.freeclsf || '' // 라디오버튼 선택 안하면 빈값으로 넘김

      // 1. 선택한 변호사 : 선택된 회원이 2명이상일 경우 (김xx#이xx 이런식으로 # 구분자를 붙임)
      this.selectCustList.forEach((item, i) => {

        this.sitem.viamembseq   = ((i == 0) ? '' : this.sitem.viamembseq   + '#') + (i+1)
        this.sitem.viamembnm    = ((i == 0) ? '' : this.sitem.viamembnm    + '#') + item.membnm
        this.sitem.viamembno    = ((i == 0) ? '' : this.sitem.viamembno    + '#') + item.membno
        this.sitem.viamembclsf  = ((i == 0) ? '' : this.sitem.viamembclsf  + '#') + item.membclsf
        this.sitem.chrgmembno   = ((i == 0) ? '' : this.sitem.chrgmembno   + '#') + item.chrgmembno
        this.sitem.chrgmembnm   = ((i == 0) ? '' : this.sitem.chrgmembnm   + '#') + item.chrgmembnm
        this.sitem.blngmembclsf = ((i == 0) ? '' : this.sitem.blngmembclsf + '#') + item.blngmembclsf
        this.sitem.blngmembno   = ((i == 0) ? '' : this.sitem.blngmembno   + '#') + item.blngmembno
        this.sitem.blngmembnm   = ((i == 0) ? '' : this.sitem.blngmembnm   + '#') + item.blngmembnm
        this.sitem.addyn        = ((i == 0) ? '' : this.sitem.addyn        + '#') + (item.addyn || '')
        this.sitem.adddt        = ((i == 0) ? '' : this.sitem.adddt        + '#') + (item.adddt && this.$moment(item.adddt).format("YYYYMMDD") || '')
      })

      // 관할기관 [직접입력] 선택 시 : 입력 받은 값을 isttoutplac로 설정
      if (this.sitem.isttoutplac == 'etc') {
        this.sitem.isttoutplac = this.sitem.isttoutplac_etc
      }

      // 위임인 구분 [직접입력] 선택 시 : 입력 받은 값을 clientclsf로 설정
      if (this.sitem.clientclsf == 'etc') {
        this.sitem.clientclsf = this.sitem.clientclsf_etc
      }

      // [상대방] 없음 체크 시 : 상대방에 '-' 값 입력
      if(this.sitem.othersideyn == 'Y'){
        this.sitem.otherside = '-'
      }

      ui.httpPost("/proc_iv/N_VIAINFO_UPD_DTL_EMP_V01",
      {
        ...this.sitem
        , accflag     : 'I' // 신규등록
        , lawyercnt   : this.selectCustList.length
      },
      ret => {
        const {msg, status, sellregdt ,sellseq} = ret.data.rs1[0];
        ui.notify(msg, {duration: 5000});

        if (status == '0') { // 작업이 정상 완료일때 신청내역 페이지로 이동
           this.$router.push({ path: 'stat_list' })
        }

      })
    },
    onChange_freememb() {
      if (T.isEmpty(this.sitem.freemembno)) {
        return this.freememb_left_cnt = ''
      }
      this.freememb_left_cnt = ` - 무료변론 가능 여부 조회중 - `
      ui.httpGet("/proc/N_GET_FREEMEMB_CNT",
        { iv_membno : this.sitem.freemembno },
        ret => {
          const {free_use_cnt_rest} = ret.data.rs1[0];
          if(free_use_cnt_rest > 0){
            this.freememb_left_cnt = `무료변론 ${ free_use_cnt_rest }회 남았습니다.`
            } else {
            this.freememb_left_cnt = `무료변론을 모두 소진하였습니다.`
          }
        }
      )

    },
    onChange_clientclsf($event) {
      if ($event.target.value == 'etc') {
        this.$nextTick(()=> this.$refs.clientclsf_etc.focus() )
      }
    },
  },
  computed:{
      openFilter(){
        return this.selectCustList.filter(function(bar){
          console.log("membstat : "+bar.membstat);
          return bar.membstat.trim()  =="A"
        });
      }
    }
}
</script>
<style scoped>
  #id_rel .toggleInfo { width:910px; height:980px; left:50%;}
  #id_rel:hover .toggleInfo{ display: inline }

  .via_kind { margin-left:50px;}
  .comment_gray li { background:none; padding-left:0}
  .t_kindsel th{ padding:10px}

  @media screen and (max-width:640px){
    #id_rel .toggleInfo { width:330px; margin-left: -300px; height:1280px}

    .via_kind { margin-left:0px;}
    .comment_gray { padding:15px;}

    .t_kindsel th{ width:auto;}
    .t_kindsel td{line-height: 2.0;}
    .tbl01 th:first-child {  letter-spacing: -2px; width:70px;}
  }


</style>